import { RunStrategy } from "multitool-sdk-core";
const ui = {
    description: "Image : Grayscale",
    defaultArgs: () => undefined,
    strategies: () => [RunStrategy.INLINE, RunStrategy.SHARED_WORKER],
    UISchema: {
        type: "VerticalLayout",
        elements: [
            {
                type: "HorizontalLayout",
                elements: [
                    {
                        type: "Control",
                        scope: "#/properties/inputImage",
                        label: "Select an Image",
                    },
                ],
            },
        ],
    },
};
export default ui;
//# sourceMappingURL=ui.js.map

ui.ArgsSchema = 
{
  "$schema": "http://json-schema.org/draft-07/schema#",
  "additionalProperties": false,
  "definitions": {
    "File": {
      "additionalProperties": false,
      "properties": {
        "downloadURL": {
          "type": "string"
        },
        "extension": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "name": {
          "type": "string"
        },
        "type": {
          "type": "string"
        }
      },
      "required": [
        "id"
      ],
      "type": "object"
    }
  },
  "properties": {
    "inputImage": {
      "$ref": "#/definitions/File"
    }
  },
  "required": [
    "inputImage"
  ],
  "type": "object"
}
